<template>
	<div class="swiper-bot">
		<ul>
			<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0s">
				<div class="le-img"><img src="@/assets/img/home/logo3.png"></div>
				<div class="ri-con">
					<div class="ri-title">阿里云服务商</div>
					<div class="ri-content">打造校园可视电话的数字化工作学习方式</div>
				</div>
			</li>
			<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
				<div class="le-img"><img src="@/assets/img/home/logo1.png"></div>
				<div class="ri-con">
					<div class="ri-title">钉钉服务商</div>
					<div class="ri-content">打造校园可视电话的数字化工作学习方式</div>
				</div>
			</li>
			<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s">
				<div class="le-img"><img src="@/assets/img/home/logo2.png"></div>
				<div class="ri-con">
					<div class="ri-title">支付宝服务商</div>
					<div class="ri-content">打造校园可视电话的数字化工作学习方式</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name: "SwiperBottom",
		data(){
			return{
				
			}
		},
		mounted() {
			
		},
		methods:{
			
		}
	}
</script>

<style>
	.swiper-bot{
		position: absolute;
		bottom: 21px;
		left: 50%;
		width: 1200px;
		height: auto;
		margin-left: -600px;
	}
	.swiper-bot ul{
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
	.swiper-bot ul li{
		width: 380px;
		height: 140px;
		padding: 35px 46px;
		background: rgba(255,255,255,0.8);
		border-radius: 10px;
		box-sizing: border-box;
		list-style: none;
	}
	.swiper-bot ul li:nth-child(1){
	}
	.swiper-bot ul li:nth-child(2){
		margin: 0 15px;
	}
	.swiper-bot .le-img{
		float: left;
		width: 70px;
		height: 70px;
		overflow: hidden;
	}
	.swiper-bot .le-img img{
		width:100%;
		height: 100%;
		object-fit: cover;
	}
	.swiper-bot .ri-con{
		float: left;
		width: 195px;
		margin-left: 21px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-content: space-between;
	}
	.swiper-bot .ri-con .ri-title{
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
	}
	.swiper-bot .ri-con .ri-content{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}
</style>
<style scoped>
	@media only screen and (min-width:992px) and (max-width:1199px) {
		.swiper-bot{
			width: 992px;
			margin-left: -496px;
		}
		.swiper-bot ul li{
			width: 320px;
			padding: 25px 26px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
		}
		.swiper-bot .ri-con{
			width: calc(100% - 80px);
			margin-left: 10px;
		}
	}
	@media only screen and (min-width:768px) and (max-width:991px) {
		.swiper-bot{
			width: 768px;
			margin-left: -384px;
		}
		.swiper-bot .ri-con{
			width: calc(100% - 70px);
			margin-left: 10px;
		}
		.swiper-bot .le-img{
			width: 60px;
			height: 60px;
		}
		.swiper-bot ul li{
			width: 246px;
			padding: 25px 16px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
		}
	}
	@media (max-width:767px) {
		.swiper-bot{
			width: 100%;
			margin-left: 0;
			left: 0%;
			bottom: 0;
		}
		.swiper-bot ul{
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: space-around;
		}
		.swiper-bot ul li{
			width: 31%;
			height: auto;
			padding: 15px 10px;
			margin: 7px 0;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			box-shadow: 0px 0px 16px 0px #EEEEEE;
			border-radius: 10px;
		}
		.swiper-bot ul li:nth-child(2){
			margin: 0;
		}
		.swiper-bot .le-img{
			width: 35px;
			height: 35px;
			margin-bottom: 10px;
		}
		.swiper-bot .ri-con{
			width: 100%;
			margin-left: 10px;
		}
		.swiper-bot .ri-con .ri-title{
			margin-bottom: 10px;
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 800;
			color: #333333;
			text-align: center;
		}
		.swiper-bot .ri-con .ri-content{
			font-size: 11px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #999999;
		}
	}
</style>
